import {
  pipe, flatten, pluck
} from 'ramda'



const hasIntersection = (arr1 = [], arr2 = []) => {
  const set = new Set(arr1);
  const intersection = arr2.find(item => set.has(item));
  return Boolean(intersection)
}



// 过滤格式，将格式生成成符合集联选择器的格式
export function restoreData(formattedData, options) {
  const { mainFunctions, jobFunctions, functionTitles } = formattedData;
  const result = [];
  // debugger

  const addAllChild = (child = [], path = []) => {
    child.map(({ children, value }) => {
      if (Boolean(children?.length)) {
        addAllChild(children, [...path, value])

      } else {
        result.push([...path, value])
      }

    })
  }

  // 核心递归函数：构建路径
  function traverse(option, path) {
    // debugger
    const { value, children } = option;

    // 判断当前值是否属于 mainFunctions / jobFunctions / functionTitles
    const isMainFunction = mainFunctions.includes(value);
    const isJobFunction = jobFunctions.includes(value);
    const isFunctionTitle = functionTitles.includes(value);

    if (isMainFunction) {
      let allJobFunctions = (children || []).map(v => {
        return v.value
      })
      // only the parent has been selected
      if (!hasIntersection(allJobFunctions, jobFunctions)) {
        addAllChild(children, [value])
        return
      }
    }

    if (isJobFunction) {
      let allJobFunctionTitles = (children || []).map(v => {
        return v.value
      })
      if (!hasIntersection(allJobFunctionTitles, functionTitles)) {
        addAllChild(children, [...path, value])
        return
      }
    }

    // 如果存在子节点，递归处理子节点
    if (
      children && children.length > 0) {
      let hasValidChild = false;
      children.forEach(child => {
        if (
          mainFunctions.includes(child.value) ||
          jobFunctions.includes(child.value) ||
          functionTitles.includes(child.value)
        ) {
          hasValidChild = true;
          traverse(child, [...path, value]);
        }
      });

      // 如果有有效的子路径，就不添加当前路径
      if (hasValidChild) return;
    }

    // 如果当前值是有效路径并且没有有效的子节点，添加到结果中
    if (isMainFunction || isJobFunction || isFunctionTitle) {
      result.push([...path, value]);
    }
  }

  // 倒推路径函数：从 functionTitles 找到完整路径
  function findPathForFunctionTitles(options, functionTitle) {
    let foundPath = null;

    function dfs(option, path) {
      if (foundPath) return; // 如果已经找到路径，停止搜索

      const { value, children } = option;

      if (value === functionTitle) {
        foundPath = [...path, value];
        return;
      }

      if (children && children.length > 0) {
        children.forEach(child => dfs(child, [...path, value]));
      }
    }

    options.forEach(option => dfs(option, []));
    return foundPath;
  }

  // 如果只传递 functionTitles，需要倒推路径
  if (mainFunctions.length === 0 && jobFunctions.length === 0 && functionTitles.length > 0) {
    functionTitles.forEach(title => {
      const path = findPathForFunctionTitles(options, title);
      if (path) result.push(path);
    });
  } else {
    // 正常递归构建路径
    options.forEach(option => {
      traverse(option, []);
    });
  }

  return result;
}


// 还原入参格式
export function restoreOriginalObject(pairs) {
  const originalObject = {
    mainFunctions: [],
    jobFunctions: [],
    functionTitles: []
  };

  if (pairs && pairs.length == 1) {
    const firstValue = pairs[0] ?? [];

    if (firstValue.length === 1) {
      originalObject.mainFunctions.push(firstValue[0])
    }

    if (firstValue.length === 2) {
      originalObject.jobFunctions.push(firstValue[1])
    }

    if (firstValue.length === 3) {
      originalObject.functionTitles.push(firstValue[2])
    }


  } else {
    pairs.forEach((pair) => {
      const [mainFunctions, jobFunctions, functionTitles] = pair;

      if (mainFunctions && !originalObject.mainFunctions.includes(mainFunctions)) {
        originalObject.mainFunctions.push(mainFunctions);
      }

      if (jobFunctions && !originalObject.jobFunctions.includes(jobFunctions)) {
        originalObject.jobFunctions.push(jobFunctions);
      }

      functionTitles && originalObject.functionTitles.push(functionTitles);
    });
  }


  return originalObject;
}

function findItemRecursively(options, seoValue) {
  for (const item of options) {
    if (item.value === seoValue) {
      return item;
    }
    if (item.children) {
      const found = findItemRecursively(item.children, seoValue);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

export function getOneLabel(options, seoValue) {
  const foundItem = findItemRecursively(options, seoValue);
  return foundItem ? foundItem.label : null;
}
// 将一个 MainJobFunction 扩展成 对应的main_functions、job_functions、function_titles
export const getJobFunctionAndJobTitles = pipe(
  pluck('sub_function_list'),     // 提取每个对象中的 sub_function_list
  flatten,                        // 将多个 sub_function_list 数组合并成一个数组
  subFunctions => ({
    subFunctions,                 // 返回所有 sub_function_list
    jobTitles: pipe(
      pluck('job_titles'),        // 提取每个 sub_function_list 中的 job_titles
      flatten                     // 将多个 job_titles 数组合并成一个数组
    )(subFunctions as any)
  })
);

// 还原function_job_title
export const filterFunctionTitles = (function_job_title = [], main_function_filter = []) => {
  const toSeo = (value) => value?.replaceAll('/', '-')?.replaceAll(' ', '-')?.toLowerCase();
  const { jobTitles: functionsTitleList } = getJobFunctionAndJobTitles(main_function_filter)
  const newJobTitles = function_job_title.map(item => {
    const matchedChild = functionsTitleList.find(child => {
      let name = toSeo(child['seo_value']) + '-' + child.id;
      return name == item;
    });

    return matchedChild ? matchedChild['seo_value'] : null;
  }).filter(Boolean);

  return (newJobTitles ?? []).join(",")
}